"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useInputHelperText } from "../../../building-blocks/inputs/InputHelperText.js";
import { ScreenReaderOnly } from "../../../utilities/accessibility/ScreenReaderOnly.js";
import "../../../utilities/accessibility/visuallyHidden.css.js";
import { createValidHtmlId } from "../../../utilities/html/index.js";
import { forwardRef } from "react";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { CheckboxRecipe, checkbox } from "./checkbox.css.js";
import { InputWrapper, LabelRecipe, InputStyleRecipe, LabelStyle, indentedDescriptionStyle } from "./shared.css.js";
import { SelectionDescription, HelperTextWrapper } from "./shared.js";
const CustomCheckbox = ({ value, disabled }) => {
  if (!value) {
    return jsx(Fragment, {});
  }
  return jsx("span", { className: ` ${checkbox({ disabled })}`, "aria-hidden": true, children: value !== "indeterminate" ? jsx(Icon, { icon: "check", size: "s" }) : jsx(Icon, { icon: "remove", size: "s" }) });
};
const defaultRender = (checkbox2, description) => jsxs(Fragment, { children: [checkbox2, jsx("div", { className: indentedDescriptionStyle, children: description })] });
const Checkbox = forwardRef(function Checkbox2({
  label,
  description,
  value,
  onChange,
  disabled,
  validity,
  id = createValidHtmlId(label),
  hideLabel = false,
  canShowErrorMessage = false,
  className,
  render = defaultRender,
  // Input element props
  onBlur,
  ...rest
}, ref) {
  const inputId = id;
  const labelId = `${id}-label`;
  const helperId = `${id}-helper`;
  const { helperTextProps, inputAriaProps } = useInputHelperText({
    id: helperId,
    validity,
    reserveSpaceForMessage: canShowErrorMessage
  });
  const descriptionElement = description ? jsx(SelectionDescription, { disabled, children: description }) : void 0;
  const checkboxElement = jsx("span", { className: `${InputWrapper} ${className}`, ref, children: jsxs("label", { htmlFor: inputId, className: LabelRecipe({ disabled }), id: labelId, children: [jsx("input", { type: "checkbox", id: inputId, disabled, onChange, checked: value === true, className: InputStyleRecipe({ disabled }), tabIndex: 0, ...inputAriaProps, ...rest }), jsx("span", { className: CheckboxRecipe({
    checked: value,
    disabled,
    validity: (validity == null ? void 0 : validity.type) === "error" ? "error" : void 0
  }), children: jsx(CustomCheckbox, { value, disabled }) }), hideLabel ? jsx(ScreenReaderOnly, { children: label }) : jsx("span", { className: LabelStyle, children: label })] }) });
  return jsx(HelperTextWrapper, { ...helperTextProps, children: render(checkboxElement, descriptionElement) });
});
export {
  Checkbox
};
